module.exports = __webpack_public_path__ + "static/media/prop-8-thumb.2dc0930d.webp";